import React from "react";
import styled from "styled-components";
import I10n from "../features/i10n";
import { m580_hotstandby_ranges } from "../constants";
import Button from "../atoms/button";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  color: #333333;
  max-width: 100%;
`;

const ButtonArea = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
`;

const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  :not(:last-of-type) {
    margin-bottom: 10px;
  }
`;

const SwitchLabel = styled.label`
  margin-left: 10px;
  cursor: pointer;
`;

const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const SectionTitle = styled.span`
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: #333333;
  margin: 10px 0px 10px 0px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`;

class DisablePowerSupplyAutoSizingContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggleItems: this.buildToggleItems(props.configuration)
    };
  }

  buildToggleItems = (config) => {

    const toggleItems = [
      {
        remoteAreaIdx: null,
        localRackIdx: null,
        label: config.name,
        pacPowerSupplyAutoSizeDisabled: config.pacPowerSupplyAutoSizeDisabled
      }
    ];

    if (!m580_hotstandby_ranges.includes(config.rangeInfo?.rangeName)) {
      toggleItems.push(
        ...(config.localRacks || []).map((localRack, index) => ({
          remoteAreaIdx: null,
          localRackIdx: index,
          label: I10n.getAndReplaceMultiple("screen.graphical_editor.modal.power_supply_autosize.local_rack", [config.name, index + 1]),
          pacPowerSupplyAutoSizeDisabled: localRack.pacPowerSupplyAutoSizeDisabled
        }))
      );
    }

    config.ioIslands.forEach((island, index) => {
      const islandConfig = island.configuration || {};
      toggleItems.push(
        {
          remoteAreaIdx: index,
          localRackIdx: null,
          label: islandConfig.name || `Remote Island ${index + 1}`,
          pacPowerSupplyAutoSizeDisabled: islandConfig.pacPowerSupplyAutoSizeDisabled || false
        },
        ...(islandConfig.localRacks || []).map((localRack, localIndex) => ({
          remoteAreaIdx: index,
          localRackIdx: localIndex,
          label: I10n.getAndReplaceMultiple("screen.graphical_editor.modal.power_supply_autosize.local_rack", [islandConfig.name || `Remote Island ${index + 1}`, localIndex + 1]),
          pacPowerSupplyAutoSizeDisabled: localRack.pacPowerSupplyAutoSizeDisabled || false
        }))
      );
    });
    return toggleItems;
  };

  handleToggle = (remoteAreaIdx, localRackIdx) => {
    this.setState((prevState) => {
      const newConfig = prevState.toggleItems.map((config) => {
        if (config.remoteAreaIdx === remoteAreaIdx && config.localRackIdx === localRackIdx) {
          return {
            ...config,
            pacPowerSupplyAutoSizeDisabled: !config.pacPowerSupplyAutoSizeDisabled
          };
        }
        return config;
      });
      return { toggleItems: newConfig };
    });
  };

  validateAndSave = () => {
    const updatedConfigs = this.state.toggleItems.map((config) => ({
      remoteAreaIdx: config.remoteAreaIdx,
      localRackIdx: config.localRackIdx,
      pacPowerSupplyAutoSizeDisabled: config.pacPowerSupplyAutoSizeDisabled,
    }));


    this.props.setPacPowerSupplyAutoSizeDisabled(updatedConfigs);

    this.props.closeModal();
  };

  render() {
    const { configurationSaver } = this.props;
    const { toggleItems } = this.state;

    return (
      <Container>
        <SelectContainer>
          <SectionTitle>{I10n.getOrDefault("screen.graphical_editor.param_button.tooltip")}</SectionTitle>
        </SelectContainer>
        <ButtonArea>
          {toggleItems.map((config) => {
            const checked = !config.pacPowerSupplyAutoSizeDisabled;
            const disabledProps = {};
            if (configurationSaver.isSaving) {
              disabledProps.disabled = true;
            }

            return (
              <SwitchWrapper key={`${config.remoteAreaIdx}-${config.localRackIdx}`}>
                <qds-switch
                  id={`${config.remoteAreaIdx}-${config.localRackIdx}-autosize-switch`}
                  onClick={() => this.handleToggle(config.remoteAreaIdx, config.localRackIdx)}
                  checked={checked}
                  {...disabledProps}
                ></qds-switch>
                <SwitchLabel htmlFor={`${config.remoteAreaIdx}-${config.localRackIdx}-autosize-switch`}>
                  <qds-label text={`${I10n.get("screen.graphical_editor.param_button.tooltip")} - ${config.label}`}></qds-label>
                </SwitchLabel>
              </SwitchWrapper>
            );
          })}
        </ButtonArea>
        <ButtonContainer>
          <Button importance="emphasized" disabled={configurationSaver.isSaving} onClick={this.validateAndSave}>
            {I10n.get('app.action.validate')}
          </Button>
        </ButtonContainer>
      </Container>
    );
  }
}

export default DisablePowerSupplyAutoSizingContent;
